<ion-row>
    <ion-col size="12">
        <div>
            <ion-card class="card-1 list-card" style="margin-bottom: 5em">
                <div>
                    <div *ngIf="showPreDepartureRegistration" class="card-header">
                        <ion-label *ngIf="existingPreDepartureOrientation" class="section-title" color="dark-teal">
                            Attend Your Pre-Departure Orientation
                        </ion-label>
                        <ion-label *ngIf="!existingPreDepartureOrientation" class="section-title" color="dark-teal">
                            Register for Pre-Departure Orientation
                        </ion-label>
                    </div>
                    <div *ngIf="showPreDepartureRegistration">
                        <ion-card-content>
                            <div>
                                <br />
                                <ion-select
                                    ok-text="Register"
                                    [interfaceOptions]="orientationAlertOptions"
                                    placeholder="Select Date"
                                    class="pre-departure-select"
                                    [(ngModel)]="preDepartureSelection"
                                    (ionChange)="preDepartureConferenceSelected($event)"
                                >
                                    <ion-select-option *ngFor="let conference of orientations?.predepartureschedule" [value]="conference">
                                        {{ conference?.datetime | date: 'mediumDate' }}
                                        {{ conference?.datetime | date: 'shortTime' }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                            <div *ngIf="existingPreDepartureOrientation" class="ion-text-center">
                                <ion-text>
                                    <br />
                                    <p>
                                        Your Orientation starts
                                        {{ existingPreDepartureOrientation?.datetime | date: 'long' }}
                                    </p>
                                    <ion-button href="{{ existingPreDepartureOrientation?.url }}" target="_blank">
                                        <ion-text class="ion-text-wrap bold"> View my Orientation. </ion-text>
                                    </ion-button>
                                    <ion-button
                                        *ngIf="existingPreDepartureOrientation?.recordingurl"
                                        href="{{ existingPreDepartureOrientation?.recordingurl }}"
                                        target="_blank"
                                    >
                                        <ion-text class="ion-text-wrap bold"> View Orientation Recording. </ion-text>
                                    </ion-button>
                                    <ion-button
                                        *ngIf="!existingPreDepartureOrientation?.recordingurl"
                                        type="button"
                                        fill="clear"
                                        class="btn-link-text"
                                        (click)="preDepartureChange()"
                                    >
                                        <ion-text class="ion-text-wrap bold"> Change my date. </ion-text>
                                    </ion-button>
                                </ion-text>
                            </div>
                        </ion-card-content>
                    </div>
                </div>
            </ion-card>
            <ion-card class="card-1 list-card">
                <ion-card-header>
                    <div class="card-header">
                        <ion-label class="section-title" color="dark-teal">
                            <fa-icon [icon]="faCheckSquare"></fa-icon>
                            Prior to your first day checklist
                        </ion-label>
                    </div>
                </ion-card-header>
                <ion-card-content>
                    <ion-list class="mb">
                        <ion-item
                            *ngFor="let question of (toolService.content | async)?.application?.components?.firstdayChecklists?.beforeFirstDay?.checklist"
                            lines="none"
                        >
                            <ion-label class="ion-text-wrap">{{ question }}</ion-label>
                            <ion-checkbox slot="start"></ion-checkbox>
                        </ion-item>
                    </ion-list>

                    <div class="card-header mb">
                        <ion-label class="section-title" color="dark-teal">
                            <fa-icon [icon]="faCheckSquare"></fa-icon>
                            On your first day checklist
                        </ion-label>
                    </div>
                    <ion-list>
                        <ion-item
                            *ngFor="let question of (toolService.content | async)?.application?.components?.firstdayChecklists?.onFirstDay?.checklist"
                            lines="none"
                        >
                            <ion-label class="ion-text-wrap">{{ question }}</ion-label>
                            <ion-checkbox slot="start"></ion-checkbox>
                        </ion-item>
                    </ion-list>
                </ion-card-content>
            </ion-card>
        </div>
    </ion-col>
</ion-row>
